<app-title-component [data]="{name : 'Avenant'}"></app-title-component>

<div class="page-container p-4 bg-light min-vh-100">
  <mat-card appearance="outlined" class="main-insurance-card border-0 shadow-sm">
    
    <!-- Zone de recherche intelligente unique -->
    <mat-card-header class="p-3 border-bottom bg-white">
      <div class="w-100 max-width-md">
        <mat-form-field appearance="outline" class="w-100 search-field-clean">
          <mat-label>Rechercher par Police, Immatriculation ou Châssis</mat-label>
          <input matInput #searchInput [formControl]="refControl" (keydown.enter)="loadAssurance()" placeholder="Ex: POL-12345, LT-890-XX...">
          <mat-icon matPrefix class="text-muted">search</mat-icon>
          
          @if (searchInput.value !== '') {
            <button mat-icon-button matSuffix color="warn" (click)="resetSearch()" class="me-1">
              <mat-icon>close</mat-icon>
            </button>
          }
          @if (loading()) {
            <mat-spinner matSuffix diameter="24" class="me-2"></mat-spinner>
          }
          @if (refControl.dirty && refControl.invalid) {
            <mat-error>Saisie invalide</mat-error>
          }
        </mat-form-field>
      </div>
    </mat-card-header>

    @if (show()) {
      <mat-card-content class="p-4 bg-white">
        <div class="row g-4">
          
          <div class="col-12 col-md-5 border-end-panel pe-md-4">
            
            <div class="d-flex align-items-center justify-content-between mb-4 pb-2 border-bottom">
              <h2 class="h5 fw-bold text-dark m-0">Police : {{ assurance.police }}</h2>
            </div>

            <div class="info-list-modern">
              
              <div class="info-row">
                <span class="info-label">Bureau</span>
                <span class="info-value fw-semibold text-dark">{{ site.name }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Collaborateur</span>
                <span class="info-value text-secondary">{{ collaborateur.name }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Émis par</span>
                <span class="info-value text-secondary">{{ assurance.last_editor_name }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Émis le</span>
                <span class="info-value text-dark fw-medium">{{ assurance.created_at | date:'dd/MM/yyyy' }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Assuré</span>
                <span class="info-value fw-semibold text-primary">
                  {{ assure.firstname ? (assure.firstname + ' ' + assure.lastname) : assure.societe }}
                  @if (assure.gender) {
                    <small class="text-muted ms-1 fw-normal">({{ assure.gender }})</small>
                  }
                </span>
              </div>

              <div class="info-row">
                <span class="info-label">Véhicule</span>
                <span class="info-value fw-medium text-dark">{{ vehicule.marque }} {{ vehicule.model }}</span>
              </div>

              <div class="info-row sub-row rounded-2 px-2 py-1.5 my-1">
                <span class="info-label text-muted">Immatriculation</span>
                <span class="info-value badge-mono">{{ vehicule.immatriculation }}</span>
              </div>

              <div class="info-row sub-row rounded-2 px-2 py-1.5 my-1">
                <span class="info-label text-muted">Châssis</span>
                <span class="info-value small-mono text-break">{{ vehicule.chassis }}</span>
              </div>

              <div class="info-row pt-2 mt-2 border-top border-light">
                <span class="info-label">Date d'effet</span>
                <span class="info-value text-success fw-semibold">{{ assurance.date_effet | date:'dd/MM/yyyy' }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Date de fin</span>
                <span class="info-value text-danger fw-semibold">{{ assurance.date_fin | date:'dd/MM/yyyy' }}</span>
              </div>

            </div>
          </div>


          <!-- Colonne Droite : Actions & Historique des Avenants -->
          <div class="col-12 col-md-7 position-relative">
            
            <div class="d-flex gap-2 justify-content-start justify-content-md-end mb-4">
              <button mat-flat-button color="primary" (click)="openAddAvenantModal()" class="px-3">
                <mat-icon class="me-1">add_circle_outline</mat-icon>
                <span>Nouvel avenant</span>
              </button>
              <button mat-stroked-button color="primary" (click)="openAvenantPrintLink(assurance.id)" matTooltip="Visuel du contrat" class="px-3">
                <mat-icon class="me-1">print</mat-icon>
                <span>Imprimer</span>
              </button>
            </div>

            @if (loading()) {
              <div class="table-loading-overlay d-flex align-items-center justify-content-center">
                <mat-spinner diameter="44"></mat-spinner>
              </div>
            }

            <div class="table-responsive border rounded-3">
              <table mat-table [dataSource]="dataSource" matSort class="w-100 premium-table">

                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Avenant </th>
                  <td mat-cell *matCellDef="let row" data-label="Avenant">
                    @switch (row.name) {
                      @case ('annule') { <span class="badge-status status-cancelled">Annulation</span> }
                      @case ('suspendu') { <span class="badge-status status-suspended">Suspension</span> }
                      @case ('remise') { <span class="badge-status status-active">Remise en vigueur</span> }
                      @case ('immat') { <span class="badge-status status-info">Changement Immatriculation</span> }
                      @case ('conducteur') { <span class="badge-status status-info">Changement Conducteur</span> }
                      @case ('vehicule') { <span class="badge-status status-info">Transfert de garanties</span> }
                      @case ('renouvelle') { <span class="badge-status status-info">Renouvellement</span> }
                      @case ('changeName') { <span class="badge-status status-info">Changement de nom</span> }
                      @default { <span class="badge-status status-neutral">{{ row.name }}</span> }
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="editor_name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Éditeur </th>
                  <td mat-cell *matCellDef="let row" data-label="Éditeur" class="text-secondary small"> {{ row.editor_name }} </td>
                </ng-container>

                <ng-container matColumnDef="created_at">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Effectué le </th>
                  <td mat-cell *matCellDef="let row" data-label="Effectué le" class="text-muted small"> {{ row.created_at | date:'shortDate' }} </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef sticky class="text-end"> </th>
                  <td mat-cell *matCellDef="let row" class="text-end"></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>

          </div>
        </div>
      </mat-card-content>
    }
  </mat-card>
</div>

